<template>
  <div>
    <div class="change-picture">
      <div class="picture">
        <div class="picture-input">
          <img :src="getUserLoged.PhotoProfile" />
          <button>
            <font-awesome-icon class="icon" icon="pen" />
          </button>
        </div>
      </div>
      <div class="resumen">
        <h1>{{ getUserLoged.name }}</h1>
        <p>{{ getUserLoged.username }}</p>
        <p>{{ getUserLoged.companyName }}</p>
      </div>
    </div>
    <v-form class="form-Edit-Profile">
      <v-container>
        <v-row class="d-flex justify-space-between my-0">
          <v-col class="pa-0" cols="12" md="4">
            <v-text-field
              class="force-font"
              v-model="firstname"
              label="First name"
              placeholder="First name"
              required
            ></v-text-field>
          </v-col>

          <v-col class="pa-0" cols="12" md="4">
            <v-text-field
              v-model="lastname"
              label="Last name"
              placeholder="Last name"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="my-0">
          <v-col class="pa-0" cols="12" md="12">
            <v-text-field
              v-model="email"
              label="E-mail"
              placeholder="E-mail"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="d-flex justify-space-between my-0">
          <v-col class="pa-0" cols="12" md="4">
            <v-text-field
              v-model="phoneNumber"
              label="Phone Number"
              placeholder="Phone Number"
              required
            ></v-text-field>
          </v-col>

          <v-col class="pa-0" cols="12" md="4">
            <v-text-field
              v-model="company"
              label="Company"
              placeholder="Company"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="d-flex justify-center my-0">
          <v-btn
            class="white--text text-btn-EditProfile"
            depressed
            color="#238EF6"
            style="text-transform: capitalize"
            data-v-step="18"
          >
            Save
          </v-btn>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters("UserManager", ["getUserLoged"]),
  },
  data: () => ({
    firstname: "",
    lastname: "",
    email: "",
    phoneNumber: "",
    company: "",
  }),
  created() {
    let nombreCompleto = this.getUserLoged.name.split(" ");

    this.firstname = nombreCompleto[0];

    this.firstname = nombreCompleto[0] + " " + nombreCompleto[1];

    this.lastname = nombreCompleto[nombreCompleto.length - 1];
    this.email = this.getUserLoged.email;
    this.company = this.getUserLoged.companyName;
    this.phoneNumber = this.getUserLoged.telephone;
  },
};
</script>

<style>
.force-font {
  font-family: "PT Sans", sans-serif !important;
  font-weight: 400 !important;
}
.text-btn-EditProfile {
  font-family: "Poppins", sans-serif;
  font-weight: bold;
}
.change-picture {
  margin: 10px 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.change-picture .picture-input {
  width: 100%;
  position: relative;
}
.change-picture .picture-input img {
  width: 100%;
  border-radius: 50%;
  border: 1px solid var(--firts-color);
}
.change-picture .picture-input button {
  position: absolute;
  bottom: 2%;
  right: 0.5%;
  border-radius: 50%;
  width: 25%;
  height: 25%;
  background: #4791ff;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}
.change-picture .resumen {
  font-family: "Poppins", sans-serif;
  font-weight: bold;
  color: var(--dark-firts-color);
  margin-left: 15px;
}
.change-picture .resumen h1 {
  font-size: 1.5rem;
}
.change-picture .resumen p {
  font-size: 0.8rem;
  opacity: 0.4;
  padding: 0;
  margin: 0;
}
/*=============================================
ESCRITORIO GRANDE (LG revisamos en 1366px en adelante)
=============================================*/
@media (min-width: 1200px) {
}
/*=============================================
ESCRITORIO MEDIANO O TABLET HORIZONTAL (MD revisamos en 1024px)
=============================================*/
@media (max-width: 1199px) and (min-width: 992px) {
  .form-Edit-Profile {
    width: 50%;
    margin: 0 auto;
  }
}
/*=============================================
ESCRITORIO PEQUEÑO O TABLET VERTICAL (SM revisamos en 768px)
=============================================*/
@media (max-width: 991px) and (min-width: 768px) {
}
/*=============================================
MOVIL (XS revisamos en 320px)
=============================================*/
@media (max-width: 767px) {
  .form-Edit-Profile {
    width: 100% !important;
  }
  .change-picture .resumen h1 {
    font-size: 1rem;
  }
}
</style>